import type { MailboxInfo, UnifiedInboxMailboxInfo } from "owa-client-types";

const unifiedInboxSourceId = "UnifiedInboxSourceId";

/**
 * Returns a MailboxInfo for the unified inbox that shows data from the specified accounts
 * @param accountsMailboxInfos Mailbox infos of the accounts to show in the unified inbox
 * @returns A mailboxInfo for the unified inbox
 */
export function createMailboxInfoForUnifiedInboxWithMailboxInfos(accountsMailboxInfos: MailboxInfo[]): UnifiedInboxMailboxInfo {
    return {
        type: "UnifiedInbox",
        userIdentity: unifiedInboxSourceId, // use the sourceId as the userIdentity
        mailboxSmtpAddress: "Unified Mailbox",
        mailboxRank: "UnifiedInbox",
        sourceId: unifiedInboxSourceId,
        diagnosticData: "ALSLUnifiedInbox",
        accountsMailboxInfos,
    };
}
